import ProductItem from '../components/product/ProductItem';

export default class StaticSearch {
  constructor(section) {
    const productItems = section.el.querySelectorAll('[data-product-item]');
    [...productItems].forEach(productItem => {
      new ProductItem(productItem);
    });
  }
}
